import Notify from 'quasar/src/plugins/notify/Notify.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';;
import iconSet from "quasar/icon-set/fontawesome-v6";
import langRu from "quasar/lang/ru";
import "@quasar/extras/fontawesome-v6/fontawesome-v6.css";
import "./assets/styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";
import "@quasar/extras/roboto-font/roboto-font.css";

export default {
  lang: langRu,
  config: {
    brand: {
      primary: "#152957",
      "primary-light": "#0060fe",
      secondary: "#26A69A",
      accent: "#9C27B0",
      dark: "#1d1d1d",
      "dark-page": "#121212",
      positive: "#21BA45",
      negative: "#ff5353",
      info: "#31CCEC",
      warning: "#F2C037",

      orange: "#ffac5e",
      green: "#5ef863",
      "gray-dark": "#4b5563",
      gray: "#9ca3af",
      "gray-light": "#d1d5db",
      background: "#f2f5f8",
    },
  },
  iconSet: iconSet,
  extras: ["material-icons"],
  plugins: {
    Notify,
    Dialog,
  },
};
